import { render, staticRenderFns } from "./_Carousel.vue?vue&type=template&id=527f20e9&"
import script from "./_Carousel.vue?vue&type=script&lang=js&"
export * from "./_Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VItem } from 'vuetify/lib'
import { VItemGroup } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VWindow } from 'vuetify/lib'
import { VWindowItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VFlex,VIcon,VItem,VItemGroup,VLayout,VSpacer,VWindow,VWindowItem})
